module.exports = __webpack_public_path__ + "static/media/bi.06f36479.svg";